/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FireIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvElEQVR4nM1VvUoDQRBOoSi2igr+VIqvYCMBtQjJ7syeeM4cGuxSaKWNIOgj2Iv4AiJoYxtTCT6AQXtBLRTUQvwjMpechuT27kQjDgwcw+z3zc+3e6nUfzGNtA6GrgHcsVaAr4Hhirg2tNUycBACpJtCodD+K+BgaLMePHCFnglyjMl3g+FLRJr4UeVQ78iHQR6il63GqJQYXCrUSO82Ao30ojX31QrZCOKJunCc+UGN/Git3gROq7UxHtTF9uNHY2gnHpwrGrmcdd1+X7pf8VelvB4rOCINSVISArC4QspbCcDh5Z+AQ3U/u1HjOfoFglM7AfJF5GHDZ6KgmOVfR3TAD3bt00kmk+kA5L1IAqSnqA7C5Yl8lcu5A/6egFdiOriP6uA89BDw7GeOMzdeHWX4MyLy/dYd0Egv6XS6LciRMSnlDsuDp5GfQ0i2rQQAc9NhBEqprsbc9OJip0Z+a8p3eNJK4JMglZovj7fUmCexEJUVU3GWm/FGwdBdozIAeEWeAcdZ6JXvxvFo5Fut3ZFUEpNXUQ4kv1x8++3/gXSiDR/HghsuJq48zBTSlChD5Cf3pOZlPxa30L+wDz8UEkqThy91AAAAAElFTkSuQmCC)
 */
export const FireIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M3 14a9 9 0 1 0 18 0c0-2.63-.61-5.22-1.79-7.58L18.2 4.38a.7.7 0 0 0-1.3.18l-.78 3.9a.66.66 0 0 1-1.27.11L12.22 1.6a.9.9 0 0 0-1.48-.33l-4.2 4.2A12.07 12.07 0 0 0 3 14Zm9.26-.84a.57.57 0 0 0-1-.23L9.6 15a3.08 3.08 0 1 0 5.12.48c-.14-.26-.5-.28-.71-.06L13 16.5l-.74-3.34Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
